/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Highlights_Muscles_TitleInputs */

const en_us2_workout_highlights_muscles_title = /** @type {(inputs: Workout_Highlights_Muscles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscles worked`)
};

const pt_br2_workout_highlights_muscles_title = /** @type {(inputs: Workout_Highlights_Muscles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculos do treino`)
};

const es_419_workout_highlights_muscles_title = /** @type {(inputs: Workout_Highlights_Muscles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculos trabajados`)
};

const pt_pt2_workout_highlights_muscles_title = /** @type {(inputs: Workout_Highlights_Muscles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Músculos do treino`)
};

const fr_fr2_workout_highlights_muscles_title = /** @type {(inputs: Workout_Highlights_Muscles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscles travaillés`)
};

const de_de2_workout_highlights_muscles_title = /** @type {(inputs: Workout_Highlights_Muscles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainierte Muskeln`)
};

const it_it2_workout_highlights_muscles_title = /** @type {(inputs: Workout_Highlights_Muscles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscoli allenati`)
};

/**
* | output |
* | --- |
* | "Muscles worked" |
*
* @param {Workout_Highlights_Muscles_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_muscles_title = /** @type {((inputs?: Workout_Highlights_Muscles_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Muscles_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_muscles_title(inputs)
	if (locale === "es-419") return es_419_workout_highlights_muscles_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_muscles_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_muscles_title(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_muscles_title(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_muscles_title(inputs)
	return en_us2_workout_highlights_muscles_title(inputs)
});
export { workout_highlights_muscles_title as "workout-highlights.muscles_title" }